module.exports = __webpack_public_path__ + "static/profile-pic-21d45b4f246cbd486e521afa4b437aef.jpeg";